import styled from 'styled-components'

export const Svg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
`
